import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token if present in localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("taru_token") || localStorage.getItem("taru_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(relOrAbsUrl) {
  if (!relOrAbsUrl) return "";
  if (relOrAbsUrl.startsWith("http")) return relOrAbsUrl;
  return `${process.env.REACT_APP_BACKEND_URL}${relOrAbsUrl}`;
}

/**
 * Normalize a list-shaped API response into a plain array.
 *
 * Accepts either:
 *  - a raw array (unpaginated endpoints, e.g. /users, /product-categories)
 *  - a paginated envelope: { items: [...], total, page, page_size }
 *
 * Always returns an array — never throws — so callers can safely `.map()`
 * without every page having to know the endpoint's pagination status.
 */
export function asList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  return [];
}
